// Vue 2 Vuex Store
// 使用方法：
// 1. 已在 store/index.js 中导入并注册为 filter 模块
// 2. 在组件中使用：this.$store.dispatch('filter/addFastFilter', { gameId, data })
// 3. 获取数据：this.$store.getters['filter/getFastFilter'](gameId)

import Vue from 'vue'

import { FieldType } from '@/components/BuyGoodsList/fast/enum.js'

/**
 * 将筛选选项转换为存储格式（用于历史记录）
 * @param filterOptions 筛选选项列表
 * @returns 存储格式的筛选数据
 */
export function getStoreByFilterOptions(filterOptions) {
	const list = []
	filterOptions.forEach(item => {
		// 检查是否有有效的选择值
		const isRightArray = Array.isArray(item.value) && item.value.length
		const isRightRange = ![undefined, '', null].includes(item.value.min) || ![undefined, '', null].includes(item.value.max)
		if (isRightArray || isRightRange) {
			// 构建存储对象
			const o = {
				mappingField: item.mappingField,
				fieldType: item.fieldType,
				id: item.id,
				name: item.name,
				level: item.level,
				options: item.options,
				filterMode: item.filterMode,
				value: item.value,
				nameList: item.nameList,
				tabActiveId: item.tabActiveId,
				selectAll: item.selectAll,
				cascadeObj: item.cascadeObj
			}
			// 级联选择类型特殊处理
			if (item.fieldType === FieldType.SINGLE_CASCADE) {
				o.cascadeObj = item.cascadeObj
			}
			list.push(o)
		}
	})
	return list
}

/**
 * 商品详情数据存储 - Vuex Store
 */
export const state = () => ({
	fastFilter: {},
	generalCateFaseFilter: {},
	guideHasShow: false,
	lastIsEmpty: false,
	isGeneralGoods: false,
})
export const mutations = {
	SET_IS_GENERAL_GOODS(state, value) {
		state.isGeneralGoods = value
	},
	SET_LAST_IS_EMPTY(state, value) {
		state.lastIsEmpty = value
	},
	SET_FAST_FILTER(state, { gameId, data }) {
		// if (!state.fastFilter[gameId]) {
		// 	state.fastFilter = { ...state.fastFilter, [gameId]: [] }
		// }
        if (!state.fastFilter[gameId]) {
            Vue.set(state.fastFilter, gameId, [])
        }
		state.fastFilter[gameId].unshift(data)
		if (state.fastFilter[gameId].length > 10) {
			state.fastFilter[gameId].pop()
		}
	},
	SET_GENERAL_CATE_FILTER(state, { gameId, data }) {
		// if (!state.generalCateFaseFilter[gameId]) {
		// 	state.generalCateFaseFilter = { ...state.generalCateFaseFilter, [gameId]: [] }
		// }
        if (!state.generalCateFaseFilter[gameId]) {
            Vue.set(state.generalCateFaseFilter, gameId, [])
        }
		state.generalCateFaseFilter[gameId].unshift(data)
		if (state.generalCateFaseFilter[gameId].length > 10) {
			state.generalCateFaseFilter[gameId].pop()
		}
	},
	MOVE_TO_TOP(state, { gameId, index, isGeneral, data }) {
		const filterMap = isGeneral ? state.generalCateFaseFilter : state.fastFilter
		if (!filterMap[gameId] || index < 0 || index >= filterMap[gameId].length) {
			return
		}
        filterMap[gameId][index].list = [...data]
		// const item = filterMap[gameId][index]
        // const itemIndex = item.list.findIndex(y => y.id === data.id)
        // if (itemIndex > -1) {
        //     const itemData = item.list[itemIndex]
        //     item.list.splice(itemIndex, 1, itemData)
        //     item.list.unshift(itemData)
        // }
		// filterMap[gameId].splice(index, 1)
		// filterMap[gameId].unshift(item)
	},
	REFRESH_LATEST(state, { gameId, data, isGeneral }) {
		const filterMap = isGeneral ? state.generalCateFaseFilter : state.fastFilter
		if (filterMap[gameId]?.length) {
			if (data.length) {
				filterMap[gameId][0] = { list: data }
			}
		}
	},
	UPDATE_LATEST_FILTER(state, { gameId, key, data, isGeneral }) {
		const filterMap = isGeneral ? state.generalCateFaseFilter : state.fastFilter
		const latest = filterMap[gameId] && filterMap[gameId][0]
		if (latest) {
			latest[key] = data
			filterMap[gameId][0] = JSON.parse(JSON.stringify(latest))
		}
	},
	SET_GUIDE_HAS_SHOW(state, value) {
		state.guideHasShow = value
	},
	CLEAR_OTHER_CATE_FAST_FILTER(state) {
		state.generalCateFaseFilter = {}
	}
}
export const actions = {
	updateLastIsEmpty({ commit, state }, value) {
		// 不是成品号，不处理后面逻辑
		if (state.isGeneralGoods) return
		commit('SET_LAST_IS_EMPTY', value)
	},
	addFastFilter({ commit, dispatch, getters, state }, { gameId, data }) {
		if (!data.length) {
			dispatch('updateLastIsEmpty', true)
			return
		}

		const filterMap = getters.getFilterMap
		if (!filterMap[gameId]) {
			filterMap[gameId] = []
		}

		// 如果数据已经存在，则不添加(去重)
		const someDataIndex = filterMap[gameId]?.findIndex(item => {
			return (
				data.length === item.list.length &&
				data.every(x => {
					const v = item.list.find(y => y.id === x.id)?.value
					if (!v) {
						return false
					}
					if (Array.isArray(x.value)) {
						return x.value.sort().join(',') === v.sort().join(',')
					} else {
						return x.value?.min === v?.min && x.value?.max === v?.max
					}
				})
			)
		})

		if (someDataIndex !== -1 && state.lastIsEmpty === false) {
			commit('MOVE_TO_TOP', { gameId, index: someDataIndex, isGeneral: getters.isGeneralGoods, data })
			return
		}

        // 这里和H5有些差异 H5重置时是不重置sort 和 server等信息的
		dispatch('updateLastIsEmpty', false)

		// 将数组数据包装格式
		const filterStoreItem = {
			list: JSON.parse(JSON.stringify(data))
		}

		// 添加新数据
		if (getters.isGeneralGoods) {
			commit('SET_GENERAL_CATE_FILTER', { gameId, data: filterStoreItem })
		} else {
			commit('SET_FAST_FILTER', { gameId, data: filterStoreItem })
		}
	},
	moveToTop({ commit, getters }, { gameId, index }) {
		commit('MOVE_TO_TOP', { gameId, index, isGeneral: getters.isGeneralGoods })
	},
	refreshLatest({ commit, getters }, { gameId, data }) {
		commit('REFRESH_LATEST', { gameId, data, isGeneral: getters.isGeneralGoods })
	},
	updateLatestFilter({ commit, getters, state }, { gameId, key, data }) {
        // 新添加的逻辑：如果是成品号或最新筛选为空，则不更新
		if (getters.isGeneralGoods || state.lastIsEmpty) return
		commit('UPDATE_LATEST_FILTER', { gameId, key, data, isGeneral: getters.isGeneralGoods })
	},
	setGuideHasShow({ commit }, value) {
		commit('SET_GUIDE_HAS_SHOW', value)
	},
	clearOtherCateFastFilter({ commit }) {
		commit('CLEAR_OTHER_CATE_FAST_FILTER')
	},
}

export const getters = {
	isGeneralGoods: state => state.isGeneralGoods,
    getFilterMap: state => state.isGeneralGoods ? state.generalCateFaseFilter : state.fastFilter,
    getFastFilter: state => gameId => {
		// 返回指定游戏ID的过滤数据，如果不存在则返回空数组
		const filterMap = state.isGeneralGoods ? state.generalCateFaseFilter : state.fastFilter
		const filterItems = filterMap[gameId] || []
		return JSON.parse(JSON.stringify(filterItems))
    },
    getLatest: state => gameId => {
		// 不是成品号，不处理后面逻辑
		if (state.isGeneralGoods) return null

		const filterMap = state.isGeneralGoods ? state.generalCateFaseFilter : state.fastFilter
		if (state.lastIsEmpty) {
			return null
		}
		const filterItems = filterMap[gameId] || []
		if (filterItems.length) {
			return JSON.parse(JSON.stringify(filterItems[0]))
		}
		return null
	},
    getFastFilterByGameId: state => gameId => {
		const filterMap = state.isGeneralGoods ? state.generalCateFaseFilter : state.fastFilter
		return filterMap[gameId]
    }
}
